module.exports = __webpack_public_path__ + "static/media/backend.fe8798eb.png";